/* eslint-disable react/no-danger */
import moment from 'moment';
import React, { useState, useEffect } from 'react';

import SiteApi from '../../Api/SiteApi/SiteApi';
import { Portal } from '../../utils/Portal';

import Loader from '../loader/Loader';

import Counter from './Counter';
import NextDraw from './NextDraw';
import { renderComponent } from '../../base/loadComponent';

function CurrentJackpot({ prefix, showadditional }) {
    const [jackpot, setJackpot] = useState();
    const [nextDraw, setNextDraw] = useState();
    const [nextNextDraw, setNextNextDraw] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(getCurrentJackpot, []);

    function getCurrentJackpot() {
        SiteApi.currentJackpot().then((response) => {
            setJackpot(
                response.data.jackpot.replace(
                    process.env.MIX_CURRENCY,
                    `<span class="jackpot-currency">${process.env.MIX_CURRENCY}</span>`
                )
            );
            setNextDraw(response.data.nextDraw);
            setNextNextDraw(response.data.nextNextDraw);
            setLoading(false);
        });
    }

    const showCounter = () => moment(nextDraw) && moment().isBefore(moment(nextDraw));

    const getContent = () => (
        <>
            <div className="font-black jackpot-amount" dangerouslySetInnerHTML={{ __html: jackpot }} />
            {showCounter() && <Counter date={nextDraw} nextDate={nextNextDraw} prefix={prefix} />}
            {showadditional && (
                <Portal id="additionalData" forceClear="true">
                    <NextDraw date={nextDraw} />
                </Portal>
            )}
        </>
    );

    return <Loader isLoading={loading} elementToShow={getContent} additionalStyles="counter-current-jackpot" />;
}

export default CurrentJackpot;

renderComponent(CurrentJackpot, 'current-jackpot');
